<template>
  <Modal title="选择服务代理人" v-model="visible" width="400" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <div class="table-box tableBox">
      <Form :model="formData" ref="formValidate" class="modal-form">
        <FormItem label="服务代理人" prop="serviceAgent" :rules="$units.formRule.required('请选择')">
          <Select v-model="formData.serviceAgent" transfer clearable filterable placeholder="请选择">
            <Option v-for="(item, i) in orgUserList" :key="i" :value="item.id" :label="item.name">
              <i class="dian" :class="{'red': item.workingState == 0 ,'orange':item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </Select>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save">确认</Button>
      </div>
    </div>
  </Modal>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      visible: false,
      orgUserList: [],
      formData: {
        serviceAgent: ''
      }
    };
  },

  methods: {
    save() {
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          console.log(this.formData.serviceAgent)
          this.$emit('success', this.formData.serviceAgent)
          this.visible = false;
        }
      })
    },
    open(data) {
      this.$http({
        url: '/buz/userBase/queryUserByEntryConfig',
        type: 'get',
        data: {
          orgId: data.organizationId,
          // workingState:'1',
          // isSus:'0'
        },
      }).then((res) => {
        this.orgUserList = res.data;
      })
      this.visible = true;
      this.$refs.formValidate && this.$refs.formValidate.resetFields();
    }
  }
};
</script>
<style lang="scss" scoped>
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35BF3F;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);

  &.red {
    background: #E3461F;
  }
}
</style>
